/**
 * Pricing table row matchHeight
 * 
 * @since 1.0.0
* @package crunchy
 */
( function($) {
	$( document ).ready( function() {

		var table        = $( '.pricing-table' );
		var headers      = $( '.column header', table );
		var headerTitles = $( 'h4', headers );
		var rows         = $( '[data-row]', table );
		var groups       = [];

		/**
		 * Match the headers
		 */
		headers.matchHeight({
			byRow : false
		});
		headerTitles.matchHeight({
			byRow : false
		});


		/**
		 * Build the groups
		 */
		rows.each( function() {

			// get group
			var group = $( this ).data( 'row' );
			
			// create an array for the group if
			// there isn't already one.
			if ( ! ( group in groups ) ) {
				groups[ group ] = [];
			}

			groups[ group ].push( this );
		});


		/**
		 * Match them up
		 */
		for ( var group in groups ) {
			
			var children = groups[ group ];

			$( children ).matchHeight({
				byRow : false
			});
		}

	}); // document.ready
})(jQuery);
